/* * @Author: 曹俊杰 * @Date: 2022-02-17 15:04:21 * @Module: 默认layouts */
<template>
  <div>
    <defHeader v-show="!hidMenu" />
    <div :class="center1200 ? 'container' : 'container2'">
      <router-view v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" v-if="$route.meta.keepAlive" />
        </keep-alive>
        <component :is="Component" v-if="!$route.meta.keepAlive" />
      </router-view>
      <userDrawer />
      <qiyeshiming />
    </div>
    <service />
    <chaozhilibao />
    <gerenshiming />
    <servicepopup />
    <informationDetail />
    <div style="display: flex; justify-content: center">
      <a href="https://beian.miit.gov.cn/" target="_blank" class="icp"
        >豫ICP备19039737号</a
      >
    </div>
  </div>
</template>
<script>
import defHeader from "@/components/defHeader/defHeader.vue";
import userDrawer from "@/components/userDrawer/index.vue";
import qiyeshiming from "@/components/qiyeshiming/index.vue";
import gerenshiming from "@/components/gerenshiming/index.vue";
import service from "@/components/service.vue";
import chaozhilibao from "@/components/chaozhilibao/index.vue";
import servicepopup from "@/components/servicepopup/index.vue";
import informationDetail from "@/components/informationDetail/informationDetail.vue";
import { mapState } from "vuex";
export default {
  components: {
    defHeader,
    userDrawer,
    qiyeshiming,
    service,
    chaozhilibao,
    gerenshiming,
    servicepopup,
    informationDetail,
  },
  data() {
    return {
      hiddenFooter: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),
    center1200() {
      return this.$route.meta.center1200;
    },
    hidMenu() {
      return this.$route.meta.hidMenu;
    },
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.icp {
  line-height: 40px;
  text-align: center;
  color: #999999;
  font-size: 14px;
  &:hover {
    color: #0062ff;
  }
}
</style>
